<template>
  <v-container>
    <!-- Create new application or continue to an application that already exist -->
    <template v-if="!currentStep || currentStep === 0">
      <ApplicationNewOrContinue 
        @showApplication="showApplication" 
        @go-to-step="goToStep($event)"
      />
    </template>

    <template v-else>
      <!-- The stepper -->
      <v-stepper flat v-model="currentStep">
        <v-stepper-header>
          <template v-if="selectedApplication && selectedApplication.isCompanyApplication">
            <template v-for="idx in numSteps">
              <v-stepper-step :key="idx" :complete="idx < currentStep" :step="idx"></v-stepper-step>
              <v-divider :key="'div-' + idx" v-if="idx < numSteps"></v-divider>
            </template>
          </template>
          <template v-else>
            <template v-for="idx in numSteps">
              <v-stepper-step :key="idx" :complete="idx < currentStep" :step="idx"></v-stepper-step>
              <v-divider :key="'div-' + idx" v-if="idx < numSteps"></v-divider>
            </template>
          </template>
        </v-stepper-header>

        <!-- The steps -->
        <v-stepper-items>
          <v-stepper-content step="1">
            <ApplicationWelcome :step="1" @goToStep="goToStep" v-if="currentStep === 1" />
          </v-stepper-content>
          <v-stepper-content class="ma-0 pa-0" step="2">
            <ApplicationInformation :step="2" @goToStep="goToStep" :showDocumectsFeature="showDocumectsFeature" v-if="currentStep === 2" />
          </v-stepper-content>
          <v-stepper-content step="3">
            <ApplicationProfession :step="3" @goToStep="goToStep" :showDocumectsFeature="showDocumectsFeature" v-if="currentStep === 3" />
          </v-stepper-content>
          <v-stepper-content step="4">
            <ApplicationProfessionOrientation
              :step="4"
              @goToStep="goToStep"
              :showDocumectsFeature="showDocumectsFeature"
              v-if="currentStep === 4"
            />
          </v-stepper-content>

          <!-- <v-stepper-content step="8">
            <ApplicationDepartments
              :step="8"
              @goToStep="goToStep"
            ></ApplicationDepartments>
          </v-stepper-content>

          <v-stepper-content step="9">
            <ApplicationMessage :step="9" @goToStep="goToStep" />
          </v-stepper-content>
          <v-stepper-content step="10">
            <ApplicationReview :step="10" @goToStep="goToStep" />
          </v-stepper-content>
          <v-stepper-content step="11">
            <ApplicationThanks :step="11" @goToStep="goToStep" />
          </v-stepper-content> -->
          <template v-if="showDocumectsFeature">
            <v-stepper-content step="5">
              <ApplicationDocuments :step="5" @goToStep="goToStep" v-if="currentStep === 5" />
            </v-stepper-content>
            <v-stepper-content step="6">
              <ApplicationCourses :step="6" @goToStep="goToStep" v-if="currentStep === 6" />
            </v-stepper-content>
            <v-stepper-content step="7">
              <ApplicationCompanies :step="7" @goToStep="goToStep" :showDocumectsFeature="showDocumectsFeature" v-if="currentStep === 7" />
            </v-stepper-content>
            <v-stepper-content step="8">
              <ApplicationDepartments
                :step="8"
                @goToStep="goToStep"
                :nextPage="'ApplicationMessage'"
                v-if="currentStep === 8"
              ></ApplicationDepartments>
            </v-stepper-content>
            <v-stepper-content step="9">
              <ApplicationMessage :step="9" @goToStep="goToStep" :showDocumectsFeature="showDocumectsFeature" v-if="currentStep === 9" />
            </v-stepper-content>
            <v-stepper-content step="10">
              <ApplicationReview :step="10" @goToStep="goToStep" :showDocumectsFeature="showDocumectsFeature" v-if="currentStep === 10" />
            </v-stepper-content>
            <v-stepper-content step="11">
              <ApplicationThanks :step="11" @goToStep="goToStep" v-if="currentStep === 11" />
            </v-stepper-content>
          </template>

          <template v-if="!showDocumectsFeature">
            <v-stepper-content step="5">
              <ApplicationCompanies :step="5" @goToStep="goToStep" :showDocumectsFeature="showDocumectsFeature" v-if="currentStep === 5" />
            </v-stepper-content>
            <v-stepper-content step="6">
              <ApplicationMessage :step="6" @goToStep="goToStep" :showDocumectsFeature="showDocumectsFeature" v-if="currentStep === 6" />
            </v-stepper-content>
            <v-stepper-content step="7">
              <ApplicationReview :step="7" @goToStep="goToStep" :showDocumectsFeature="showDocumectsFeature" v-if="currentStep === 7" />
            </v-stepper-content>
            <v-stepper-content step="8">
              <ApplicationThanks :step="8" @goToStep="goToStep" v-if="currentStep === 8" />
            </v-stepper-content>
          </template>
        </v-stepper-items>
      </v-stepper>
    </template>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import API from '@/services/api.js'
// new steps
import ApplicationNewOrContinue from '@/components/Application/ApplicationNewOrContinue'
import ApplicationWelcome from '@/components/Application/Apprentice/ApplicationWelcome'
import ApplicationInformation from '@/components/Application/Apprentice/ApplicationInformation'
import ApplicationProfession from '@/components/Application/Apprentice/ApplicationProfession'
import ApplicationProfessionOrientation from '@/components/Application/Apprentice/ApplicationProfessionOrientation'
import ApplicationDocuments from '@/components/Application/Apprentice/ApplicationDocuments.vue'
import ApplicationCourses from '@/components/Application/Apprentice/ApplicationCourses.vue'
import ApplicationDepartments from '@/components/Application/Apprentice/ApplicationDepartments'

import ApplicationCompanies from '@/components/Application/Apprentice/ApplicationCompanies'
import ApplicationMessage from '@/components/Application/Apprentice/ApplicationMessage'
import ApplicationReview from '@/components/Application/Apprentice/ApplicationReview'
import ApplicationThanks from '@/components/Application/Apprentice/ApplicationThanks'
import get from 'lodash/get'

// @group Application-Apprentice
// Main component for apprentice application
export default {
  name: 'ApplicationStart',

  props: {
    // The step number if there is any from draft applications
    setStep: Number
  },

  components: {
    ApplicationNewOrContinue,
    ApplicationWelcome,
    ApplicationInformation,
    ApplicationProfession,
    ApplicationDepartments,
    ApplicationProfessionOrientation,
    ApplicationDocuments,
    ApplicationCourses,
    ApplicationCompanies,
    ApplicationMessage,
    ApplicationThanks,
    ApplicationReview
  },

  data: () => ({
    numSteps: 8
  }),

  created() {
    if (!this.selectedApplication || +this.$route.params.id !== this.selectedApplication.id) {
      this.initApplication()
    }

    if (typeof this.setStep !== 'undefined') {
      this.setCurrentStep(this.setStep)
    }
    if (this.showDocumectsFeature) {
      this.numSteps = 10
    }
  },

  watch: {
    /**
     * @vuese
     * Used to store the current step to store when step is changed
     * @arg The argument is an integer value representing the current step number
     */
    setStep(step) {
      this.setCurrentStep(step)
    },
    '$route.query.step': {
      handler: function (step) {
        this.goToStep(step)
      },
      deep: true,
      immediate: true
    },
    currentStep(newVal, oldVal) {
      if (this.currentStep && this.selectedApplication.id) {
        const appId = this.selectedApplication.id
        this.$router.push({path: `/application/${appId}`, query: {step: this.currentStep}})
      }
    },
    $route(to, from) {
      this.setSelectedApplication(null)
      this.initApplication()
    }
  },

  computed: {
    ...mapGetters('application', ['selectedApplication', 'currentStep']),
    ...mapGetters('currentuser', ['currentUser', 'isLoggedIn', 'isApprentice', 'isInstructor'])
  },
  beforeMount() {
    window.addEventListener('beforeunload', this.preventNav)
  },

  computed: {
    ...mapGetters('application', ['selectedApplication', 'currentStep']),
    ...mapGetters('currentuser', ['currentUser', 'isLoggedIn', 'isApprentice', 'isInstructor']),

    showDocumectsFeature() {
      if (process.env.VUE_APP_DOCUMENTS_COURSES_SHOW) {
        return Boolean(process.env.VUE_APP_DOCUMENTS_COURSES_SHOW === 'true')
      }
      return false
    }
  },

  methods: {
    ...mapActions('application', ['setSelectedApplication', 'setCurrentStep']),

    preventNav(event) {
      if (!this.isEditing) return
      event.preventDefault()
      window.onbeforeunload = null
      setTimeout(function () {
        window.location = '/'
      }, 0)

      return ''
    },

    /**
     * @vuese
     * Used to  move from step to step based on current step
     * @arg The argument is an integer value representing the current step number
     */
    goToStep(step) {
      switch (step) {
        case '+1':
          this.setCurrentStep(this.currentStep + 1)
          break
        case '+2':
          this.setCurrentStep(this.currentStep + 2)
          break
        case '+3':
          this.setCurrentStep(this.currentStep + 3)
          break
        case '-1':
          this.setCurrentStep(this.currentStep - 1)
          break
        case '-2':
          this.setCurrentStep(this.currentStep - 2)
          break
        case '-3':
          this.setCurrentStep(this.currentStep - 3)
          break
        case 'last':
          this.setCurrentStep(this.numSteps)
          break
        default:
          this.setCurrentStep(Number(step))
      }

      //- Scroll to top on page
      this.$nextTick(this.$scrollToTop)
    },
    /**
     * @vuese
     * Used to fetch an application if there is any / or create a new one
     * @arg The argument is an integer value representing the application id if it exist
     */
    initApplication() {
      const id = +this.$route.params.id
      if (this.$route.params.id && Number.isNaN(id)) {
        this.$router.push({path: `/application`})
        return
      }
      if (id > 0) {
        //- Old application
        API.getApplication(id)
          .then(response => {
            this.setSelectedApplication(response.data)
            if (response.data && response.data.isCompanyApplication === true) {
              //Very bad Design , Need to be changed in the future
              if (this.showDocumectsFeature) {
                this.numSteps = [1, 2, 5, 6, 8, 9, 10, 11]
              } else {
                this.numSteps = [1, 2, 6, 7, 8, 9, 10]
              }
            } else {
              this.numSteps = 8
            }
            //- Calculate what's done
            if (this.selectedApplication.step && this.selectedApplication.step < this.numSteps) {
              this.setCurrentStep(this.selectedApplication.step)
            } else {
              if ( Number(get(this, '$route.query.step', 1)) > 1 )
                return this.$router.replace({ name: 'ApplicationStart' })
              this.setCurrentStep(1)
            }
          })
          .catch(error => {
            this.$router.push({path: `/application`})
            console.log('There was an error:', error)
          })
      } else if (id === -1) {
        this.setSelectedApplication({})
        //- New application start from step 1
        this.setCurrentStep(1)
      }
    },
  showApplication(obj) {
      if (this.selectedApplication && this.selectedApplication.id === obj.id) {
        const appId = this.selectedApplication.id
        this.$router.push({path: `/application/${appId}`, query: {step: 1}})
        return
      }
      this.$router.push({path: `/application/${obj.id}`})
    }
  },
  /**
   * @vuese
   * Used to set to an empty state the popstate event before the component is destroyed
   * @arg Called with no argument
   */
  beforeDestroy() {
    window.onpopstate = () => {}
  }
}
</script>

<style></style>
